import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../datas/DateUtil";
import { FxmsData } from "../../datas/FxData";
import { FxmsEvent } from "./../../actions/FxEvent";
import { AttrListEdit } from "../../datas/OpClass";
import { FxDashEditInfo } from "../FxDashBoard";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";

HighchartsMore(Highcharts);

class High extends Component {
  constructor(props) {
    super(props);

    this.chart = null;
  }

  setChart(chart) {
    this.chart = chart;
  }

  render() {
    const { title, psItem, datas } = this.props;
    const psName = psItem ? psItem.psName : "";
    const psUnit = psItem ? psItem.psUnit : "";

    const style = {};
    style.height = this.props.height ? this.props.height + "px" : "100%";
    style.minWidth = this.props.width ? this.props.width + "px" : "100%";
    style.width = style.minWidth;
    style.minHeight = style.height;

    const options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
        backgroundColor: "rgba(255,255,255, 0.1)",
      },
      title: {
        text: title,
        style: { color: "white" },
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          },
        },
      },
      series: [
        {
          name: psName,
          colorByPoint: true,
          data: datas,
        },
      ],
    };

    return (
      <HighchartsReact
        className="HighChart"
        callback={this.setChart}
        containerProps={{ style: style }}
        highcharts={Highcharts}
        options={options}
      />
    );
  }
}

export function FxPieChartConfig(fxUiGrp, fxUiGrpItem) {
  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect(10, "moNo", "관리대상", 300, "mo", {
    moClass: "SENSOR",
  });
  setList.makeAttrSelect(20, "psId", "수집항목", 300, "psItem", {
    moClass: "SENSOR",
  });
  setList.makeAttrButton(30, "cmdApplyDb", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;
}

/**
 * 라인 챠트
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp
 * @param {*} fxUiGrpItem
 * @returns
 */
export const FxPieChart = (props) => {
  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [title, setTitle] = React.useState("noknown");
  const [psItem, setPsItem] = React.useState(null);
  const [mo, setMo] = React.useState({});
  const [datas, setDatas] = React.useState([]);
  const [intervalId, setIntervalId] = React.useState(null);

  useEffect(() => {
    onFxmsEvent(fxUiGrpItem.attrObj);

    const id = setInterval(showDatas, 30000);
    setIntervalId(id);

    return () => {
      if (intervalId != null) {
        clearInterval(intervalId);
      }
      FxmsEvent.removeEventListener(id);
      // console.log('컴포넌트가 화면에서 사라짐');
    };
  }, []);

  async function showDatas() {
    if (mo.moNo === undefined || psItem === null) {
      return;
    }

    setTitle(mo.moName + "(" + psItem.psName + ")");

    const res = await FxmsData.GET("fxmsPs/minMaxAgvList", {
      moNo: mo.moNo,
      psId: psItem.psId,
    });

    if (res === undefined || res === null) return;

    let datas = [];
    let result = res.data.result;
    if (result) {
      result.forEach((value, index, result) => {
        if ((index = 0)) {
          datas.push({
            name: value.psDate,
            y: value.avgValue,
            sliced: true,
            selected: true,
          });
        } else {
          datas.push({ name: value.psDate, y: value.avgValue });
        }
      });
      //y값은 100으로 비율을 나눠서 저장해야 함. 
      setDatas(datas);
    } else {
      setTitle(mo.moName + " :: " + psItem.psName + " 데이터 조회 오류!!");
    }
  }

  useEffect(() => {
    showDatas();
  }, [mo, psItem]);

  // 다른 컴포넌에서 보낸 이벤트를 받는 함수
  async function onFxmsEvent(obj) {
    if (obj && obj.moNo) {
      const mo = await FxmsData.getMo(obj.moNo);
      setMo(mo);
      console.log("*** FxPieChart *** mo = ", mo);
    }
    if (obj && obj.psId) {
      const psItem = FxmsData.getPsItem(obj.psId);
      console.log("*** FxPieChart *** psItem = ", psItem);
      if (psItem) {
        setPsItem(psItem);
      }
    }
  }

  //id가 설정되어 있으면 다른 컴포넌트에서 보낸 이벤트를 받기위해 등록한다.
  if (id) {
    FxmsEvent.addEventListener(id, onFxmsEvent);
  }

  if (editable) {
    return <FxDashEditInfo>파이차트</FxDashEditInfo>;
  }

  return (
    <High
      title={title}
      mo={mo}
      psItem={psItem}
      datas={datas}
      height={fxUiGrpItem.height}
      width={fxUiGrpItem.width}
    />
  );
};

export default FxPieChart;
